import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function iinValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    let iin = ''

    if (control.value) {
      iin = control.value.toString()
    }

    const b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    const b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
    let a = [];
    let controll = 0;

    for (let i = 0; i < 12; i++) {
      a[i] = parseInt(iin.substring(i, i + 1));
      if (i < 11) controll += a[i] * b1[i];
    }
    controll = controll % 11;

    if (controll === 10) {
      controll = 0;
      for (let i = 0; i < 11; i++) {
        controll += a[i] * b2[i];
      }
      controll = controll % 11;
    }

    if (controll !== a[11]) {
      return {'iinNotValid': true}
    }

    return null;

  }
}
